import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "../shared/baseQuery"; 

export const postMatchSlice = createApi({
  reducerPath: "postMatchListApi",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    getPostMatchList: builder.query({
      query: () => `/PostMatchReport`,
    }),
  }),
});

export const { useGetPostMatchListQuery } = postMatchSlice;
